/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "{3DC00F17-135D-4645-82F1-C2B05731AE23}",
  "sitecoreApiHost": "https://bmc.edu.sa",
  "jssAppName": "application-form",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/api/application-form",
  "graphQLEndpoint": "https://bmc.edu.sa/api/application-form?sc_apikey={3DC00F17-135D-4645-82F1-C2B05731AE23}"
};